<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/exclamation.svg?raw'
export default {
  name: 'IconExclamation',
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
